<rask-page
  pageTitle="Rebus messages"
  noPadding>
  <ng-container headerContent>
    <rask-list #messagesList [rowSelectable]="true" [data]="tableData" [useClientFilter]="true"
      clientFilterResultText="st meddelanden">
      <rask-list-column header="Typ" field="typ">
        <ng-template let-row="row">
          <span>{{row.typ}}</span>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Body" field="body">
        <ng-template let-row="row">
          <pre (click)="prompt('Body', row.formattedBody, 'text')" class="truncated-json">{{ row.truncatedBody }}</pre>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Headers" field="Headers" width="500px">
        <ng-template let-row="row">
          <pre (click)="prompt('Headers', row.parsedHeaders, 'json')" class="truncated-json">{{ row.truncatedHeaders }}</pre>
        </ng-template>
      </rask-list-column>
    </rask-list>
  </ng-container>


  <ng-container footerContent>
    @if (type !== 'AzureServiceBus' || subQueue !== null) {
      <rask-button color="primary" negative [disabled]="!hasSelectedItems()" (click)="deleteSelectedMessages()">
        <span class="fas fa-trash"></span>
        Ta bort meddelanden
      </rask-button>
    }
    @if (subQueue !== null) {
      <rask-button color="secondary" [disabled]="!hasSelectedItems()" (click)="resendSelectedMessages()">
        <span class="fas fa-copy"></span>
        Skicka om meddelanden
      </rask-button>
    }
    <rask-list-selected-items [data]="getSelectedListItems()" (removeFromSelection)="removeFromSelection($event)">
    </rask-list-selected-items>
  </ng-container>
</rask-page>